// ABOUTME: Shows confirmation modal after login if user has pending trainer invitation.
// ABOUTME: Reads bindTrainerLink from localStorage and redirects to binding page on confirm.

import { useTranslation } from "react-i18next"
import { useState } from "react"
import { CConfirmModal } from "@shared/ui"
import { addLogError } from "@/model/logger"
import { STORAGE_KEYS } from "@shared/constants/storageKeys"

// We can't fetch the trainer's profile before the athlete-coach relationship
// exists — `user(userID)` returns ErrAccessDenied, which previously left this
// modal permanently hidden. Show a generic confirmation instead.

const parseBindLink = (bindLink: string | null): string | null => {
  if (!bindLink) return null
  try {
    const parsed: unknown = JSON.parse(bindLink)
    return typeof parsed === "string" ? parsed : null
  } catch (e: unknown) {
    addLogError("Invalid bindLink in localStorage:", e)
    return null
  }
}

export const CheckBindTrainer = () => {
  const { t } = useTranslation()
  const bindLink = localStorage.getItem(STORAGE_KEYS.BIND_TRAINER_LINK)
  const bindURL = parseBindLink(bindLink)

  const [isConfirm, setIsConfirm] = useState(true)

  const onSuccessBindTrainer = () => {
    if (bindURL) {
      localStorage.removeItem(STORAGE_KEYS.BIND_TRAINER_LINK)
      window.location.href = bindURL
    }
  }

  const handleCancel = () => {
    localStorage.removeItem(STORAGE_KEYS.BIND_TRAINER_LINK)
    setIsConfirm(false)
  }

  if (!bindURL) return null

  return (
    <CConfirmModal
      isShow={isConfirm}
      onClose={handleCancel}
      onSuccess={onSuccessBindTrainer}
      description={`${t("common.wouldLikeConnectTrainer")}?`}
      confirmText={t("common.yes")}
    />
  )
}
